import React from 'react';

const Toast = ({ message }) => {
  if (!message) return null;

  return (
    <div
      className="fixed bottom-24 left-1/2 z-50 px-4 py-2.5 rounded-xl text-sm font-medium text-white shadow-lg pointer-events-none animate-screenFade"
      style={{
        transform: 'translateX(-50%)',
        backgroundColor: 'var(--brand-primary)',
        maxWidth: 'calc(100vw - 2rem)',
        whiteSpace: 'nowrap',
      }}
    >
      {message}
    </div>
  );
};

export default Toast;
